export enum Branches {
  MRH = "MRH",
  PJ = "PJ",
  SA = "SA",
}
